import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { IMAGES } from "@/data/content";

export default function Legal() {
  return (
    <div data-testid="page-legal">
      <PageHero
        overline="— Legal"
        title="Privacy &"
        accent="terms of use."
        body="A summary of how Designlayer handles project information, deliverables and engagement boundaries."
        image={IMAGES.textureMood}
        testid="legal-hero"
      />

      <section className="max-w-3xl mx-auto px-6 md:px-10 py-20 space-y-12 text-[#A3A3A3] leading-relaxed">
        <Reveal>
          <h2 className="font-serif text-3xl text-[#EAEAEA] mb-4">Service boundaries</h2>
          <ul className="space-y-3 list-disc pl-6">
            <li>Final field measurements remain the responsibility of the contracting party unless specifically included.</li>
            <li>Drawings and models must be reviewed and approved before manufacturing or construction.</li>
            <li>CNC output must be tested before full production use.</li>
            <li>Machine-specific commissioning may require an authorized technician.</li>
            <li>Supplier product codes, pricing, availability and specifications must be confirmed before ordering.</li>
            <li>Software behaviour may vary by version, catalogue, database and post-processor.</li>
            <li>Client-provided construction and hardware standards must be verified.</li>
            <li>Renderings are visual representations and may differ from physical materials, lighting and final site conditions.</li>
            <li>Structural, architectural, electrical, plumbing, fire-code and professional-engineering requirements must be reviewed by appropriately qualified professionals.</li>
            <li>Automation reduces predictable errors but does not eliminate the need for quality control and production verification.</li>
          </ul>
        </Reveal>

        <Reveal>
          <h2 className="font-serif text-3xl text-[#EAEAEA] mb-4">Privacy</h2>
          <p>Information submitted through the Designlayer contact form (name, company, email, phone, project description) is stored securely and used only to respond to your enquiry and to scope potential work. We do not sell or share lead data with third parties.</p>
          <p className="mt-4">Confidential databases, proprietary company standards, customer information or sensitive project files should not be transmitted through the website. Confidentiality agreements and a secure file-transfer process will be arranged once an engagement is initiated.</p>
        </Reveal>

        <Reveal>
          <h2 className="font-serif text-3xl text-[#EAEAEA] mb-4">Trademark notice</h2>
          <p>All product names, software names, trademarks and manufacturer names are the property of their respective owners. Designlayer should be described as an independent service provider unless a formal partnership or authorization is specifically documented.</p>
        </Reveal>
      </section>
    </div>
  );
}
